exports = module.exports = require("./../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".CopyrightNotice.inverted{color:hsla(0,0%,100%,.95)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./~/sass-loader?outputStyle=expanded!./src/components/copyrightNotice/CopyrightNotice.scss
// module id = 70
// module chunks = 0